

























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
@Component
export default class ViewDetail extends Vue {
  /** 表格列属性 */
  protected columns: TypeBase.TableColumn[] = [];
  /** 流水日志 */
  @Prop({ type: Object, default: () => {} })
  private detailsData!: TypeHwcStatement.HwcDetails;

  protected created(): void {
    this.setColumns();
  }
  /**
   * 设置列表属性
   */
  private setColumns() {
    const h = this.$createElement;
    this.columns = [
      {
        title: this.t('序号'),
        dataIndex: 'index',
        scopedSlots: { customRender: 'index' },
      },
      {
        title: this.t('费用类型'),
        dataIndex: 'fee_type_name',
        filterEmpty: true,
      },
      {
        title: this.t('账户编号'),
        dataIndex: 'account_code',
        filterEmpty: true,
      },
      {
        title: () => {
        return <div>
          <span>{this.t('发生金额')}</span>
            <a-popover content={this.t('正数表示扣款，负数表示退款。')}>
              <a-icon class='ml-5' type='question-circle' />
            </a-popover>
          </div>;
        },
        dataIndex: 'amount',
        scopedSlots: { customRender: 'amount' },
        align: 'right',
      },
      {
        title: this.t('单号'),
        dataIndex: 'order_number',
        filterEmpty: true,
      },
      {
        title: this.t('出账状态'),
        dataIndex: 'billing_status_text',
        filterEmpty: true,
      },
      {
        title: this.t('发生时间'),
        dataIndex: 'transaction_time',
        filterEmpty: true,
      },
    ];
  }
}
